import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchMyCases } from "../../../api/auth";
import {
  quickViewDetails,
  getCaseDocuments,
  createCaseDocument,
} from "../../../api/cases";

export const fetchRespondentCases = createAsyncThunk(
  "respondent/fetchRespondentCases",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchMyCases();
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || "Failed to fetch cases",
      );
    }
  },
);

export const quickViewDetailsAction = createAsyncThunk(
  "respondent/quickViewDetails",
  async (values, { rejectWithValue }) => {
    try {
      const result = await quickViewDetails(values);
      return result[0] ?? [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.message ||
          "Failed to load case details",
      );
    }
  },
);

export const fetchCaseDocumentsAction = createAsyncThunk(
  "respondent/fetchCaseDocuments",
  async (values, { rejectWithValue }) => {
    try {
      const data = await getCaseDocuments(values);
      return {
        documents: data?.documents || [],
        cases: data?.cases || [],
        count: data?.count || 0,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
          error.message ||
          "Failed to fetch documents",
      );
    }
  },
);

export const createCaseDocumentAction = createAsyncThunk(
  "respondent/createCaseDocument",
  async (formData, { rejectWithValue }) => {
    try {
      const data = await createCaseDocument(formData);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to upload document",
      );
    }
  },
);
